const $ = jQuery.noConflict();
// import Global from './global';

'use strict';
const Header = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domHeader: $('.site-header'),
	classHeaderScroll: 'is-sticky',

	/** @description Initialize */
	init: function() {
		this.headerScroll();
	},

	headerScroll: function() {
		$(document).on('scroll', function() {
			const scrollTop = $(document).scrollTop();
			if(scrollTop > 10) {
				Header.$domHeader.addClass(Header.classHeaderScroll);
			} else {
				Header.$domHeader.removeClass(Header.classHeaderScroll);
			}
		});
	},
};

export default Header;